import React from "react";
import useAPI from "hooks/useAPI";
import { loadStripe } from "@stripe/stripe-js";
import useAccount from "hooks/useAccount";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import useBookings from "hooks/useBookings";

let stripe = null;

const useStripe = () => {
  const { API } = useAPI({});
  const { getAndSetUser } = useAccount();
  const { getCost } = useBookings({});
  const history = useHistory();
  const getStripeConfigAndLoadStripe = async () => {
    const stripeConfig = await API.get(`/stripe/config`);
    stripe = await loadStripe(stripeConfig.publishableKey);
    console.log("getStripeConfigAndLoadStripe -> got stripe", stripe);
  };
  const addCard = async (bookingId) => {
    const { stripeSessionId } = await API.post(`/stripe/checkout`, {
      bookingId,
    });
    console.log("got session id", stripeSessionId);
    if (!stripe) {
      await getStripeConfigAndLoadStripe();
    }
    const result = await stripe.redirectToCheckout({
      sessionId: stripeSessionId,
    }); //AFTER THE USER HAS SETUP FUTURE PAYMENTS, USER IS REDIRECTED TO CHARGE URL
  };

  return {
    getStripe: async () => {
      if (!stripe) {
        await getStripeConfigAndLoadStripe();
      }
      return stripe;
    },
    collectPayment: async (bookingId, user) => {
      if (!bookingId) {
        alert("No booking id");
        console.error("No booking id");
        return;
      }

      if (!user) {
        alert("no user!");
        return;
      }

      //Check if user has setup future payments already
      // let user = await getAndSetUser(); //Updates user and for a quick ref of it
      console.log(
        "collectPayment user",
        user.stripe,
        user?.stripe?.checkoutSessionId,
        user?.stripe?.setupIntentId,
        user
      );
      if (!user.stripe?.checkoutSessionId || !user.stripe?.setupIntentId) {
        // const { stripeSessionId } = await API.post(`/stripe/checkout`, {
        //   bookingId,
        // });
        // console.log("got session id", stripeSessionId);
        // const result = await stripe.redirectToCheckout({
        //   sessionId: stripeSessionId,
        // }); //AFTER THE USER HAS SETUP FUTURE PAYMENTS, USER IS REDIRECTED TO CHARGE URL

        let cost = await getCost(bookingId);

        await addCard(bookingId);
      } else {
        history.push("/charge?bookingId=" + bookingId);
        console.log("user has already setup future payments", user);
        console.log("TODO -> charge user");
      }
    },
    addCard,
  };
};

export default useStripe;
